import React from "react";
import Plot from "react-plotly.js";

const Histogram = ({ data }) => {
  return (
    <Plot
      data={[
        {
          x: data,
          type: "histogram",
        },
      ]}
      layout={{ 
        title: "<b>Histogram Graph</b>",
        autosize: true,
        margin: { l: 40, r: 30, b: 50, t: 50 }, 
      }}
      style={{ width: '100%', height: '100%' }}
      useResizeHandler={true}
    />
  );
};

export default Histogram;
